import { IMarketingCampaign } from "@core/models";
import { MARKETING_CAMPAIGN_TYPES } from "@core/constants";

export const campaign = {
  [IMarketingCampaign.actionBtnLabel]: "Action",
  [IMarketingCampaign.cancelBtnLabel]: "Cancel",
  [IMarketingCampaign.code]: "123",
  [IMarketingCampaign.createdAt]: "01-01-2022",
  [IMarketingCampaign.etabId]: "5",
  [IMarketingCampaign.campaignId]: "321",
  [IMarketingCampaign.message]: "message",
  [IMarketingCampaign.param]: "",
  [IMarketingCampaign.route]: "",
  [IMarketingCampaign.seen]: false,
  [IMarketingCampaign.sendDate]: "02-01-2022",
  [IMarketingCampaign.title]: "title",
  [IMarketingCampaign.type]: MARKETING_CAMPAIGN_TYPES.SIMPLE,
};
